// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"e2-z","yourQuestionLabel":"f2-z","notAuthedMessage":"g2-z","form":"h2-z","textarea":"i2-z","error":"j2-z","disabled":"k2-z","edited":"l2-z","submit":"m2-z"};